import { IDiscoverTreeNode } from '../../../Interfaces/discover.interfaces';

export const sanitizeNodeForUpload = (detailedNode: IDiscoverTreeNode) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { id, location, parent_list, path, title, ...node } = detailedNode;
    return node;
};

//To help create the path
export const inferLocation = (pathArray: string[]) => {
    return pathArray.length > 1 ? 'other' : 'top';
};

//(e.g. ("top", ["id1", "id2"])  => "/top/id1/id2" )
export const joinPath = (location: string, pathArray: string[]) => {
    return location + '/' + pathArray.join('/');
};
//Returns consecutive paths of the target, nested location
export const findPathArray = (paths: string[], flatData: any[string]) => {
    //We use flatData below to get the entire tree, not just the current level
    return paths.map(idx => flatData[idx].id);
    // : [detailedNode.node.id] //Simply return the node's id if it is top-level..otherwise another top-level is identified as it's parent
};

//Remove the children array from node...useful for sanitizing data prior to upload
export const nodeWithoutChildren = (node: IDiscoverTreeNode) => {
    const { children, ...nextNode } = node;
    return nextNode;
};

//Returns true if node is of type "list"
export const isList = (node: any) => {
    return node.content.type === 'list';
};
export const isTop = (node: any) => {
    return node.location === 'top';
};

//Returns all "list" nodes with their children from the treeData
export const getListNodes = (nodes: any) => {
    return nodes.filter((node: any) => isList(node));
};
export const formatLeaf = (node: any, idx: number) => {
    const { children, expanded, id, location, parent_list, title, ...value } = node; //Remove ui-tree related info from node
    return { [id]: { ...value, index: idx } }; //Bind visual index to the index property
};
export const getChildren = (node: any) => {
    return node.children;
};

export const hasChildren = (node: any) => {
    return node.children && node.children.length;
};

export const prepareTreeDataForUpload = (nodes: any) => {
    const top = generateTopNode(nodes);
    const other = generateOtherNode(getListNodes(nodes));
    return { top, other };
};

export const generateTopNode = (nodes: IDiscoverTreeNode[]) => {
    let top: any = {};
    nodes.forEach((node, idx) => {
        top = { ...top, ...formatLeaf(node, idx) };
        // if (isTop(node)) top = { ...top, ...formatLeaf(node, index) }
    });
    return top;
};
//Method for assembling data to store parent/child relationships
export const generateOtherNode = (nodes: IDiscoverTreeNode[]) => {
    let other: any = {};
    bubbleListRefToTop(nodes);
    function bubbleListRefToTop(nodes: IDiscoverTreeNode[]) {
        nodes.forEach(node => {
            if (isList(node)) {
                //If it's a list, there will be a reference at the top-level in "other"
                let tmp = {};
                if (hasChildren(node)) {
                    getChildren(node).forEach((child: any, idx: number) => {
                        tmp = { ...tmp, ...formatLeaf(child, idx) };

                        if (isList(child)) {
                            bubbleListRefToTop(getChildren(node));
                        }
                    });
                }
                other[node.id] = tmp;
            }
        });
    }
    return other;
};
